/* eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
import { loadAwards } from './actions/awardActions';
import { loadExhibitions } from './actions/exhibitionActions';
import { loadArtworks } from './actions/artworkActions';
import { loadSketchADays } from './actions/sketchADayActions';
import 'bootstrap';
import './styles/styles.scss';

const store = configureStore();
store.dispatch(loadAwards());
store.dispatch(loadExhibitions());
store.dispatch(loadArtworks());
store.dispatch(loadSketchADays());

render(
    <AppContainer>
        <Root store={store} history={history} />
    </AppContainer>,
    document.getElementById('app')
);

if (module.hot) {
    module.hot.accept('./components/Root', () => {
        const NewRoot = require('./components/Root').default;
        render(
            <AppContainer>
                <NewRoot store={store} history={history} />
            </AppContainer>,
            document.getElementById('app')
        );
    });
}



// WEBPACK FOOTER //
// ./src/index.js